import { useMutation } from "@tanstack/react-query";
import { sendInvoiceToCustomer } from "@/api/v1-jwt/invoice/invoice";
import { useAuth } from "@/providers/auth";

export const useSendReminder = () => {
  const { cognitoId, clientId, userRole } = useAuth();

  const userId =
    userRole === "admin" || userRole === "auth_user" ? clientId : cognitoId;

  return useMutation({
    mutationFn: (id) =>
      sendInvoiceToCustomer({
        userId,
        invoiceId: id,
        reminder: true,
      }),
  });
};
